import { render } from "./RenderWord.component.vue?vue&type=template&id=680d5d76"
import script from "./RenderWord.component.vue?vue&type=script&lang=js"
export * from "./RenderWord.component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__